












import { Component, Vue } from "vue-property-decorator";
import GlobalAlerts from "@/components/GlobalAlerts.vue";
import GenericDialog from "@/components/GenericDialog.vue";
@Component({
  components: { GlobalAlerts, GenericDialog },
})
export default class PublicLayout extends Vue {}
